import { defineMessages } from 'react-intl';

const messages = defineMessages({
    emailPlaceholder: {
        id: 'EmailPasswordSignUpForm.emailPlaceholder',
        defaultMessage: 'Enter your email',
        description: 'Placeholder for the email input in the sign up form',
    },
    passwordPlaceholder: {
        id: 'EmailPasswordSignUpForm.passwordPlaceholder',
        defaultMessage: 'Enter your password',
        description: 'Placeholder for the password input in the sign up form',
    },
});

export default messages;
